import React from 'react';
import PropTypes from 'prop-types';
import { Text, Flex, Icon } from "../";

var FeatureListItem = function FeatureListItem(_ref) {
  var variant = _ref.variant,
      text = _ref.text,
      subText = _ref.subText,
      iconName = _ref.iconName;
  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Icon, {
    size: 24,
    name: iconName
  }), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    ml: "4"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: variant === 'lg' ? 'lg' : 'base'
  }, text), subText && /*#__PURE__*/React.createElement(Text, {
    fontSize: "xs",
    color: "greys.steel"
  }, subText)));
};

FeatureListItem.defaultProps = {
  variant: 'lg',
  iconName: 'done'
};
FeatureListItem.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['lg', 'sm']),
  subText: PropTypes.string,
  iconName: PropTypes.string
};
export default FeatureListItem;